import React from 'react';
import { useParams } from 'react-router-dom';
import styles from './PolicyPage.module.css';

const PolicyPage: React.FC = () => {
  const { type } = useParams<{ type: string }>();

  const getContent = () => {
    if (type === 'private') {
      return {
        title: '개인정보처리방침',
        content: (
          <>
            <section className={styles.section}>
              <h2>1. 개인정보의 처리 목적</h2>
              <p>
                한국승강기안전기술관리원(이하 '기술관리원')은 다음의 목적을 위하여 개인정보를 처리합니다.
                처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며,
                이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라
                별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
              </p>
            </section>

            <section className={styles.section}>
              <h2>2. 개인정보의 처리 및 보유 기간</h2>
              <p>
                기술관리원은 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터
                개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를
                처리·보유합니다.
              </p>
            </section>

            <section className={styles.section}>
              <h2>3. 정보주체의 권리·의무 및 그 행사방법</h2>
              <p>
                정보주체는 기술관리원에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를
                행사할 수 있습니다.
              </p>
              <ul>
                <li>개인정보 열람요구</li>
                <li>오류 등이 있을 경우 정정 요구</li>
                <li>삭제요구</li>
                <li>처리정지 요구</li>
              </ul>
            </section>

            <section className={styles.section}>
              <h2>4. 처리하는 개인정보의 항목</h2>
              <p>기술관리원은 다음의 개인정보 항목을 처리하고 있습니다.</p>
              <ul>
                <li>필수항목: 성명, 연락처(전화번호, 이메일), 주소</li>
                <li>선택항목: 회사명, 부서명, 직책</li>
              </ul>
            </section>

            <section className={styles.section}>
              <h2>5. 개인정보의 파기</h2>
              <p>
                기술관리원은 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가
                불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.
              </p>
            </section>

            <section className={styles.section}>
              <h2>6. 개인정보 보호책임자</h2>
              <div className={styles.contact}>
                <p><strong>개인정보 보호책임자</strong></p>
                <p>성명: 채성준 이사장</p>
                <p>연락처: 010-3227-2112</p>
                <p>이메일: kesti2026@daum.net</p>
              </div>
            </section>

            <section className={styles.section}>
              <p className={styles.effectiveDate}>
                본 개인정보처리방침은 2024년 1월 1일부터 적용됩니다.
              </p>
            </section>
          </>
        ),
      };
    } else if (type === 'email') {
      return {
        title: '이메일무단수집거부',
        content: (
          <>
            <section className={styles.section}>
              <p className={styles.highlight}>
                본 웹사이트에 게시된 이메일 주소가 전자우편 수집 프로그램이나
                그 밖의 기술적 장치를 이용하여 무단으로 수집되는 것을 거부하며,
                이를 위반시 정보통신망법에 의해 형사 처벌됨을 유념하시기 바랍니다.
              </p>
            </section>

            <section className={styles.section}>
              <h2>관련 법령</h2>
              <div className={styles.lawBox}>
                <h3>정보통신망 이용촉진 및 정보보호 등에 관한 법률</h3>
                <p><strong>제50조의2 (전자우편주소의 무단 수집행위 등 금지)</strong></p>
                <ol>
                  <li>
                    누구든지 전자우편주소의 수집을 거부하는 의사가 명시된 인터넷
                    홈페이지에서 자동으로 전자우편주소를 수집하는 프로그램 그 밖의
                    기술적 장치를 이용하여 전자우편주소를 수집하여서는 아니된다.
                  </li>
                  <li>
                    누구든지 제1항의 규정을 위반하여 수집된 전자우편주소를
                    판매·유통하여서는 아니된다.
                  </li>
                  <li>
                    누구든지 제1항 및 제2항의 규정에 의하여 수집·판매 및 유통이
                    금지된 전자우편주소임을 알고 이를 정보 전송에 이용하여서는 아니된다.
                  </li>
                </ol>

                <p className={styles.penalty}>
                  <strong>제50조의2 위반시 처벌 규정</strong><br />
                  1년 이하의 징역 또는 1천만원 이하의 벌금
                  (정보통신망법 제65조의2 제1항 제3호)
                </p>
              </div>
            </section>

            <section className={styles.section}>
              <h2>문의사항</h2>
              <p>
                이메일 무단수집과 관련하여 문의사항이 있으시면 아래 연락처로
                연락주시기 바랍니다.
              </p>
              <div className={styles.contact}>
                <p>Tel: 010-3227-2112</p>
                <p>Email: kesti2026@daum.net</p>
                <p>주소: (우) 13943 경기도 안양시 동안구 흥안대로 500 (서현빌딩) 6층 602호</p>
              </div>
            </section>
          </>
        ),
      };
    }

    return {
      title: '정책 페이지',
      content: <p>요청하신 페이지를 찾을 수 없습니다.</p>,
    };
  };

  const { title, content } = getContent();

  return (
    <div className={styles.policyPage}>
      <div className={styles.container}>
        <h1 className={styles.title}>{title}</h1>
        <div className={styles.content}>{content}</div>
      </div>
    </div>
  );
};

export default PolicyPage;
